import Vue from 'vue';
import VueRouter from 'vue-router';
import PageStyle from '@/enumerations/PageStyle.json';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'hash',
	routes: [
		{
			path: '/',
			component: () => import('./pages/StreamPage.vue'),
			beforeEnter(to, from, next) {
				if (to.query.live === 'true') {
					return next('/board');
				}
				return next();
			}
		},
		{
			path: '/twitch-player',
			component: () => import('./pages/TwitchPlayer.vue')
		},
		{
			path: '/results',
			component: () => import('./pages/Homepage.vue')
		},
		{
			name: 'board',
			path: '/board',
			component: () => import('./pages/Board.vue'),
			props: route => ({
				apiToken: route.query.apiToken
			})
		},
		{
			name: 'ResultDisplay',
			path: '/result-display',
			redirect: to => {
				if (
					to.params.pageStyle &&
					to.params.pageStyle === PageStyle.LeslycVip
				) {
					return { name: 'SlotMachine', params: to.params, query: to.query };
				}

				return { name: 'PixelStreamer', params: to.params, query: to.query };
			}
		},
		{
			name: 'PixelStreamer',
			path: '/pixel-streamer',
			component: () => import('./pages/Stream.vue'),
			props: route => ({
				pixelStreamVersion: route.query.pixelStreamVersion,
				apiToken: route.query.apiToken,
				pageStyle: route.params.pageStyle,
				sortition: route.params.sortition
			})
		},
		{
			name: 'SlotMachine',
			path: '/slot-machine',
			component: () => import('./pages/SlotMachine.vue'),
			props: route => ({
				apiToken: route.query.apiToken,
				pageStyle: route.params.pageStyle,
				sortition: route.params.sortition
			})
		},
		{
			path: '/404',
			component: () => import('./pages/NotFound.vue')
		},
		{
			path: '*',
			redirect: '/404'
		}
	],
	linkActiveClass: 'active'
});

export default router;
